import {Duration} from 'luxon';
import {useDispatch} from 'react-redux';


import * as dateUtils from '../../../../utils/dateUtils';
import * as uuidUtils from '../../../../utils/uuidUtils';

import {notificationActions, notificationConstants} from '../index';


/**
 * Returns a function dispatching a toast message
 *
 * @returns {(function())|*}
 */
function useToastMessage() {

    const dispatch = useDispatch();

    /**
     * @param type {string} Notification type
     * @param content {string} Content to display
     * @param id {string|null} Optional id for explicit referencing
     * @param timeout {number|null} Optional timeout; defaults to toast message default timeout
     */
    return (type, content, id = null, timeout = notificationConstants.TIMEOUT_TOAST_MESSAGE_MILLIS) => {

        if (!id) {
            id = `notification-message-id-${uuidUtils.generateUuid()}`;
        }
        const postedAt = dateUtils.now();
        const removeAt = postedAt.plus(Duration.fromMillis(timeout));

        const toastMessage = {
            content,
            id,
            postedAt,
            removeAt,
            timeout,
            type
        };
        dispatch(notificationActions.onToastMessage(toastMessage));
    };
}


export default useToastMessage;
